import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import {
  addListToDropdown,
  createDropdown,
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";
import Collection from "@ckeditor/ckeditor5-utils/src/collection";
import Model from "@ckeditor/ckeditor5-ui/src/model";

import ReOrderReferencesIcon from "./icons/reorderreferences.svg";
import { CkeditorConstants } from "../../src/utils/ckeditorconstants";

const {
  command: {
    REORDER_KEYWORDS,
    RENUMBER_NUMBERED_CITATIONS,
    REORDER_UNNUMBERED_REFERENCES,
    REORDER_REFERENCES,
    REORDER_CITATIONS
  },
  dropdownLabels: {
    LABEL_REORDER_KEYWORDS,
    LABEL_RENUMBER_NUMBERED_CITATIONS,
    LABEL_REORDER_UNNUMBERED_REFERENCES,
  }
} = CkeditorConstants;

export default class ReOrderReferencesUI extends Plugin {
  init() {
    const editor = this.editor;
    const reorderreferenceslist = [
      {
        id: REORDER_KEYWORDS,
        label: LABEL_REORDER_KEYWORDS,
      },
      {
        id: RENUMBER_NUMBERED_CITATIONS,
        label: LABEL_RENUMBER_NUMBERED_CITATIONS,
      },
      {
        id: REORDER_UNNUMBERED_REFERENCES,
        label: LABEL_REORDER_UNNUMBERED_REFERENCES,
      },
    ];

    editor.ui.componentFactory.add(REORDER_REFERENCES, (locale) => {
      let dropdownView = createDropdown(locale);
      dropdownView.isEnabled = true;
      dropdownView.id = REORDER_REFERENCES;

      addListToDropdown(
        dropdownView,
        getDropdownOptionsDefinitions(reorderreferenceslist)
      );

      dropdownView.buttonView.set({
        icon: ReOrderReferencesIcon,
        class: "reorderreferencesicon",
        label: "Reorder cross-references",
        tooltip: true,
      });

      dropdownView.on("execute", (eventInfo) => {
        const id = eventInfo && eventInfo.source && eventInfo.source.id;
        if (id === RENUMBER_NUMBERED_CITATIONS) {
          editor.execute(REORDER_CITATIONS);
          editor.editing.view.focus();
        } else if (id === REORDER_UNNUMBERED_REFERENCES) {
          editor.fire(REORDER_UNNUMBERED_REFERENCES);
        } else if (id === REORDER_KEYWORDS) {
          editor.fire(REORDER_KEYWORDS);
        }
      });

      return dropdownView;
    });
  }
}

function getDropdownOptionsDefinitions(reorderreferenceslist) {
  const itemDefinitions = new Collection();
  for (const reordertype of reorderreferenceslist) {
    let definition = {
      type: "button",
      model: new Model({
        id: reordertype.id,
        label: reordertype.label,
        withText: true,
        tooltip: true,
      }),
    };

    // Add the item definition to the collection.
    itemDefinitions.add(definition);
  }
  return itemDefinitions;
}
